module.exports = __webpack_public_path__ + "media/images/flags/4x3/ita-73869f99889d1d10e7e0b85bd7a10912.svg";